import type { JSX } from "react";
import LottieLite from "./LottieLite";
import splashAnimation from "../../assets/lottie/BYTEMONK-LOGO.json";

const SplashScreen = (): JSX.Element => {
  return (
    <div
      style={{
        backgroundColor: "#000",
        height: "100vh",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        fontFamily: "'Space Grotesk', sans-serif",
      }}
    >
      {/* Compute animation duration from frames/fr and set speed so it finishes in 1s */}
      <LottieLite
        animationData={splashAnimation}
        style={{ width: 200, height: 200 }}
        // Compute playback speed so the animation completes in 500ms
        // speed = originalDuration / desiredDuration
        speed={(() => {
          try {
            const fr = splashAnimation?.fr ?? 60;
            const ip =
              typeof splashAnimation?.ip === "number" ? splashAnimation.ip : 0;
            const op =
              typeof splashAnimation?.op === "number" ? splashAnimation.op : 0;
            const frames = Math.max(0, op - ip);
            const duration = fr > 0 ? frames / fr : 0; // original duration in seconds
            const target = 0.5; // desired duration in seconds (500ms)
            return duration > 0 ? duration / target : 1;
          } catch {
            return 1;
          }
        })()}
      />
      <h3 className="mt-4 text-white">Loading ByteMonk...</h3>
    </div>
  );
};

export default SplashScreen;
